import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class InternshipScheduleSeatApi extends EntityApi {
    protected static GET_COLLECTION = "/api/internship-schedule-seats";

    protected static POST_COLLECTION = "/api/internship-schedule-seats";

    protected static GET_ITEM = "/api/internship-schedule-seats/{id}";

    protected static PUT_ITEM = "/api/internship-schedule-seats/{id}";

    protected static PATCH_ITEM = "/api/internship-schedule-seats/{id}";

    protected static DELETE_ITEM = "/api/internship-schedule-seats/{id}";

    protected static GET_COLLECTION_MY_INTERNSHIP =
        "/api/internship_schedule_seats/get-for-school";

    protected static GET_ITEM_MY_INTERNSHIP =
        "/api/internship_schedule_seats/{id}/get-for-school";

    protected static GET_COLLECTION_FIND_MY =
        "/api/internship_schedule_seats/find-my";

    public static async getCollectionMyInternship<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_INTERNSHIP,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getItemMyInternship<R>(
        id: number | string,
        extraParams: PrimitiveObject = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_ITEM_MY_INTERNSHIP,
        };
        return this.getItem(id, extraParams);
    }

    public static async getCollectionFindMy<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_FIND_MY,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
